import HTMLReactParser from 'html-react-parser';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';

import { set, useFormContext } from 'react-hook-form';
import Loader from './Loader';
import RegistrationFormProgrammeInnovation from './RegistrationFormProgrammeInnovation';
import RegistrationFormSection from './RegistrationFormSection';
import { isDev } from '../utils';
import { v4 as uuidv4 } from 'uuid';
import styled, { css } from 'styled-components';
import useApiUrlTranslation from './useApiUrlTranslation';
import parse from 'html-react-parser';
import RegistrationFormSubtitleSection from './RegistrationFormStyleSection';

const MainListContainer = styled.ul`

list-style-type: none;

${props =>
        props.columns &&
        css`
        columns:${props.columns}
    `};

@media (max-width: 768px) {
    columns:1
  }`;

const OnboardingFormGeographiqueShowInput = ({ showBody, setShowBody,
    sectionBodyRevealInput, sectionBodyHideInput }) => {

    const { t } = useApiUrlTranslation();

    const randomUUID = uuidv4();

    return <div className='py-3'><label className="font-normal  block">
        <input
            name={`collectif_geographique_reveal_${randomUUID}`}
            type="radio"
            onChange={() => setShowBody(!showBody)} /> {sectionBodyRevealInput}
        {
            //Je recherche des distributeurs dans de nombreux pays pour mon accélération
        }


        {
            ""
            //t('form.sections.global_funding_connector.cherche_revendeurs')
        }
    </label>
        <label className="font-normal  block">
            <input
                name={`collectif_geographique_reveal_${randomUUID}`}
                type="radio"
                onChange={() => setShowBody(!showBody)}
                checked={!showBody} /> {sectionBodyHideInput}
            {
                //Je recherche des distributeurs dans de nombreux pays pour mon accélération
            }


            {
                "	"
                //t('form.sections.global_funding_connector.cherche_revendeurs')
            }
        </label>
    </div>
}

const OnboardingFormGeographique = ({ showBody, setShowBody, instructions, sectionBodyIntro, contact }) => {

    const { register, formState } = useFormContext();

    const { t, i18n } = useApiUrlTranslation();

    const [distributionJuridiqueIsOk, setDistributionJuridiqueIsOk] = useState(false);
    const [distributionRessourcesDisponibles, setDistributionRessourcesDisponibles] = useState(false);
    const [distributionProduitConforme, setDistributionProduitConforme] = useState(false);
    const [distributionProduitDisponible, setDistributionProduitDisponible] = useState(false);


    useEffect(() => {

        if (contact) {

            setDistributionJuridiqueIsOk(contact.distribution_juridique_is_ok);
            setDistributionRessourcesDisponibles(contact.distribution_ressources_disponibles);
            setDistributionProduitConforme(contact.distribution_produit_conforme);
            setDistributionProduitDisponible(contact.distribution_produit_disponible);
        }
    }, [contact])

    return <div className='mb-5'>
        {instructions}
        {/* {sectionBodyIntro} */}


        <p className="2 hidden">Afin de nous assurer que vous disposez d'une stratégie de distribution indirecte de vos solutions, merci de cocher les cases ci-dessous :</p>

        {HTMLReactParser(t('form.templates.startup-onboarding.collectifsGeographiquesSectionInstruction'))}

        <div className="mb-5">

            <div className="mt-3">
                <input type="checkbox"
                    {...register("distribution_produit_disponible")}
                    checked={distributionProduitDisponible == 1}
                    onChange={() => setDistributionProduitDisponible(distributionProduitDisponible == 1 ? 0 : 1)}

                    value={distributionProduitDisponible} />  {HTMLReactParser(t('form.sections.recherche_distributeurs_section.distribution_produit_disponible'))}  </div>
            <div>
                <input type="checkbox"
                    {...register("distribution_produit_conforme")}
                    checked={distributionProduitConforme == 1}
                    onChange={() => setDistributionProduitConforme(distributionProduitConforme == 1 ? 0 : 1)}

                    value={distributionProduitConforme} /> {HTMLReactParser(t('form.sections.recherche_distributeurs_section.distribution_produit_conforme'))} </div>
            <div>

                <input type="checkbox"
                    {...register("distribution_ressources_disponibles")}
                    checked={distributionRessourcesDisponibles == 1}
                    onChange={() => setDistributionRessourcesDisponibles(distributionRessourcesDisponibles == 1 ? 0 : 1)}

                    value={distributionRessourcesDisponibles} /> {HTMLReactParser(t('form.sections.recherche_distributeurs_section.distribution_ressources_disponibles'))}
            </div>
            <div>

                <input type="checkbox"
                    {...register("distribution_juridique_is_ok")}
                    checked={distributionJuridiqueIsOk == 1}
                    onChange={() => setDistributionJuridiqueIsOk(distributionJuridiqueIsOk == 1 ? 0 : 1)}

                    value={distributionJuridiqueIsOk} />	 {HTMLReactParser(t('form.sections.recherche_distributeurs_section.distribution_juridique_is_ok'))}


                <div className="hidden">
                    Je spécifie le type de rémunération au distributeirs générée par la vente de ma solution :
                    <ul className="list-disc pl-10 pt-3">
                        <li>Rémunération des ventes one shot : Je dispose d'un programme d'apport d'affaires uniquement sur le new business.
                            Merci de m'envoyer un NDA afin de la présenter aux distributeurs du réseau myGlobalVillage et préparer mon intervention devant le Tech'porter counsil</li>
                        <li>Revenus récurrents : La vente de ma solution donne droit à des revenus récurrents (abonnement, consommables).
                            Merci de m'envoyer un NDA afin de la présenter ma grille de rémunération aux distributeurs du réseau myGlobalVillage et préparer mon intervention devant le Tech'porter counsil</li>
                    </ul>
                </div>
            </div>

            <p className="pt-3 hidden">Merci de détailler les pays vers lesquels les Tech'xplorateurs de myGlobalVillage peuvent vous rechercher des distributeurs/intégrateurs/revendeurs</p></div>
    </div>
}

const OnboardingFormGeographiqueEnd = ({ sectionBodyEnd }) => {

    const { t, i18n } = useApiUrlTranslation();

    if (!sectionBodyEnd) return false;

    return <div className="bg-yellow-200 text-yellow-700 p-4 border-l-4 border-yellow-500 mt-5">

        {sectionBodyEnd}
    </div>
}

const CycleLangFormItem = ({ cycleLang, register, handleChangeCheckbox, inputProps, children, idEventContactType }) => {

    if (["region", "ville", "province", "etat", "agglomeration"].includes(cycleLang.cycle_lang_categorie)) {
        return false;
    }

    return <li className='border m-1'>
        <label className="cursor-pointer hover:text-pink-700 font-normal flex items-center space-x-4" htmlFor={`cl_${cycleLang.id_cycle_lang}`} >

            <img src={cycleLang.attachedFilesCollection.find(item => item.id_attached_file_type == 65).tiny} className="w-10 rounded" />

            <input  {...register("eventCycleLang")}

                {...inputProps}

                onChange={handleChangeCheckbox}
                type="checkbox"
                id={`cl_${cycleLang.id_cycle_lang}`}
                value_={cycleLang.id_cycle_lang}
                value={JSON.stringify({ id_cycle_lang: cycleLang.id_cycle_lang, id_event_contact_type: idEventContactType })}
            />
            <span className='px-1 font-bold'>{cycleLang.nom_cycle_lang}
                {/* <span className=' py-1 px-3 bg-green-700 rounded-full text-white'>{cycleLang.cycle_lang_type}</span>  */}
            </span>
        </label>
        {children}
    </li>
}

const CycleLang = ({ cycleLang, setActiveCycleLang, cycleLangList, idEventContactType }) => {

    const { register } = useFormContext();

    const [isChecked, setIsChecked] = useState(false);

    const handleChangeCheckbox = () => {

        setIsChecked(!isChecked);
        setActiveCycleLang(cycleLang)
    }

    const arrieresPetitsEnfants = ({ child }) => {

        let childrenTypeList;

        switch (child.cycle_lang_categorie) {

            case 'continent': childrenTypeList = ['pays'];
                break;

            case 'region':
            case 'agglomeration':
            case 'pays': childrenTypeList = ['ville'];
                break;

            default: childrenTypeList = ['pays'];
        }

        const enfant = cycleLangList

            .filter(item => item.id_cycle_lang === child.id_cycle_lang)[0];

        if (!enfant) {
            return false;
        }

        const petitsEnfantsList = enfant?.children;

        return <ul
            className="pl-10"
            style={{ listStyleType: "none" }}> {petitsEnfantsList &&

                petitsEnfantsList.filter(item => !["ville", "agglomeration", "region"].includes(item.cycle_lang_categorie))
                    .filter(item => childrenTypeList.includes(item.cycle_lang_categorie))
                    .map(item => <CycleLangFormItem
                        key={item.id_cycle_lang}
                        cycleLang={item}
                        register={register}
                        handleChangeCheckbox={handleChangeCheckbox}
                        inputProps={inputProps}
                        idEventContactType={idEventContactType}

                    />)} </ul>
    }


    const petitsEnfants = ({ child }) => {

        const enfant = cycleLangList ? cycleLangList.filter(item => item.id_cycle_lang === child.id_cycle_lang)[0] : [];

        const petitsEnfantsList = enfant?.children;

        let childrenTypeList;

        switch (child.cycle_lang_categorie) {

            case 'continent': childrenTypeList = ['pays'];
                break;

            case 'region':
            case 'agglomeration':
            case 'pays': childrenTypeList = ['ville'];
                break;

            default: childrenTypeList = ['pays'];
        }

        return <ul
            className='pl-10'
            style={{ listStyleType: "none" }}> {petitsEnfantsList &&

                petitsEnfantsList
                    // .filter(item => childrenTypeList.includes(item.cycle_lang_categorie))
                    .map(item => <>
                        <CycleLangFormItem
                            cycleLang={item}
                            register={register}
                            handleChangeCheckbox={handleChangeCheckbox}
                            inputProps={inputProps}
                            idEventContactType={idEventContactType}

                        /> {arrieresPetitsEnfants({ child: item })}</>)} </ul>
    }

    const displayChildren = ({ cycleLang, children }) => {

        let childrenTypeList;

        switch (cycleLang.cycle_lang_categorie) {

            case 'continent': childrenTypeList = ['pays'];
                break;

            case 'region':
            case 'agglomeration':
            case 'pays': childrenTypeList = ['ville'];
                break;

            default: childrenTypeList = ['pays'];
        }


        return cycleLang.children && cycleLang.children
            .filter(child => childrenTypeList.includes(child.cycle_lang_categorie))
            //order by nom_cycle_lang
            .sort((a, b) => a.nom_cycle_lang.localeCompare(b.nom_cycle_lang))
            .map(child => <li style={{ listStyleType: 'none' }}>


                <input {...register("eventCycleLang")}
                    type="checkbox"
                    id={`cel_${child.id_cycle_lang}`}
                    value_={child.id_cycle_lang}
                    value={JSON.stringify({ id_cycle_lang: child.id_cycle_lang, id_event_contact_type: idEventContactType })}
                />
                <label htmlFor={`cel_${child.id_cycle_lang}`} className="font-normal">{child.nom_cycle_lang} </label>
                {petitsEnfants({ child })}
            </li>)
    }

    const inputProps = cycleLang.cycle_lang_type === 'collectif_sectoriel' && !isChecked ? {
        'data-bs-toggle': 'modal',
        'data-bs-target': '#exampleModal'
    } : '';

    const children = isDev && cycleLang.cycle_lang_type === 'collectif_geographique' ? <ul className="pl-10">{cycleLang.children && displayChildren({ cycleLang: cycleLang, children: cycleLang.children })}</ul> : ''

    if (cycleLang.cycle_lang_type === 'collectif_geographique' && cycleLang.cycle_lang_categorie !== 'continent') {

        return false
    }

    return <li className="py-1  ">
        <CycleLangFormItem
            handleChangeCheckbox={handleChangeCheckbox}
            inputProps={inputProps}
            children={children}
            register={register}
            cycleLang={cycleLang} /></li>
}

const RegistrationFormCycleLangSection = ({ title, subtitle, instructions, cycleLangTypeList,
    sectionBodyIntro, sectionBodyEnd, sectionBodyRevealInput, sectionBodyHideInput, idEventContactType,
    contact, formulaire = {} }) => {

    const { t, i18n, apiUrlTranslation } = useApiUrlTranslation();

    const { idEvent } = useParams();

    const [activeCycleLang, setActiveCycleLang] = useState({});

    const [cycleLangList, setCycleLangList] = useState(null);

    const [collectifGeographiqueList, setCollectifGeographiqueList] = useState(null);

    const [cycleLangListMain, setCycleLangListMain] = useState(null);

    const [activeCycleLangMain, setActiveCycleLangMain] = useState(null);

    const [showBody, setShowBody] = useState(false);

    const [showEditSection, setShowEditSection] = useState(false);

    const api = `https://www.myglobalvillage.com/${i18n.resolvedLanguage === 'fr' ? '' : i18n.resolvedLanguage + '/'}api/`

    const handleEditButton = (e) => {
        e.preventDefault()

        setShowEditSection(!showEditSection);
        console.log("handleEditButton")
    }

    const handleChangeActiveCycleLangMain = (e) => {

        const id_cycle_lang = e.target.value;

        const cycleLang = cycleLangListMain.filter(item => item.id_cycle_lang == id_cycle_lang)[0];

        setActiveCycleLangMain(cycleLang)
    }

    useEffect(() => {

        const getConfEventCycleLang = async () => {

            const req = `getConfEventCycleLang`;

            await fetch(`${apiUrlTranslation}?action=${req}&params= WHERE id_conf_event IN ( SELECT id_conf_event FROM conf_event WHERE id_event=${idEvent})  GROUP BY id_conf_event`)
                .then(res => res.json())
                .then(res => res.map(confEventCycleLang => confEventCycleLang.id_cycle_lang))
                .then(res => res.filter(cycleLang => cycleLangTypeList.includes(cycleLang.cycle_lang_type)))
                .then(res => setCycleLangList(res))
        }

        const fetchCycleLang = async () => {

            const filterAnte = `cycle_lang_type IN('collectif_technologique', 'collectif_sectoriel', 'collectif_geographique','collectif_linguistique', 'collectif_planaction', 'collectif_programme') AND `;
            const filter = ` id_cycle_lang IN( SELECT cl.id_cycle_lang FROM cycle_lang_event_ligne clel, events e, cycle_lang cl   WHERE 
            cl.id_cycle_lang = clel.id_cycle_lang
            AND cl.cycle_lang_type IN('collectif_planaction', 'collectif_programme')
            AND clel.id_event_ligne = e.id_event_ligne and id_event ='${idEvent}') AND cycle_lang_type IN('collectif_planaction', 'collectif_programme') AND `;

            await fetch(`${apiUrlTranslation}?action=getCycleLang&filter=${filter}`)
                .then(res => res.json())
                //.then(res => res.filter(cycleLang => cycleLangTypeList.includes(cycleLang.cycle_lang_type)))
                // .then(res => setCycleLangList(res))
                .then(res => {
                    setCycleLangList(res.filter(item => item.cycle_lang_type == "collectif_planaction").map(item => item.children).flat())
                    setCycleLangListMain(res)
                })
        }

        const fetchCollectifGeographique = async () => {

            const filter = `cycle_lang_type IN('collectif_geographique') AND `;

            await fetch(`${apiUrlTranslation}?action=getCycleLang&filter=${filter}`)
                .then(res => res.json())
                .then(res => setCollectifGeographiqueList(res))
        }

        fetchCollectifGeographique();
        //getConfEventCycleLang()
        fetchCycleLang();

    }, [i18n.resolvedLanguage]);

    return <RegistrationFormSection
        title={parse(title ?? "")}
        subtitle={subtitle}
        instructions={parse(instructions ?? "")}>


        {
            !cycleLangTypeList.includes('collectif_geographique') && cycleLangListMain && cycleLangListMain.length > 1 && <div>
                {t('form.sections.mes_plans_action.label')} {" "}
                <select className='p-2 rounded border bg-neutral-200' onChange={handleChangeActiveCycleLangMain}>
                    {/* <option value={null}>Tous</option> */}
                    {
                        cycleLangListMain.map(item => <option value={item.id_cycle_lang}>{item.nom_cycle_lang}
                            {/* - {item.cycle_lang_type} */}
                        </option>)
                    }
                </select>
            </div>
        }

        <div className='flex justify-end'>
            <button
                onClick={handleEditButton}
                className=" border-2 bg-blue-200 rounded-full w-28 text-black border-blue-600 ">
                {showEditSection ? t('form.voir_appercu') : t('form.modifier')}
            </button>
        </div>

        {/** 
        <OnboardingFormGeographiqueShowInput
            showBody={showBody}
            setShowBody={setShowBody}
            sectionBodyRevealInput={sectionBodyRevealInput}
            sectionBodyHideInput={sectionBodyHideInput}
        />
*/}
        {!showEditSection && <>

            {cycleLangTypeList.includes('collectif_geographique') && <OnboardingFormGeographique
                showBody={showBody}
                setShowBody={setShowBody}
                sectionBodyIntro={sectionBodyIntro}
                contact={contact}
                instructions_={<div className='alert alert-info'>{HTMLReactParser(instructions)}</div>}
            />}


            {activeCycleLangMain && <ul className="grid lg:grid-cols-3  md:grid-cols-2 grid-cols-1 divide-y "
                columns={cycleLangTypeList.includes('collectif_geographique') ? 3 : 2}>


                {activeCycleLangMain.children
                    .filter(cycleLang =>
                        cycleLang.cycle_lang_state == 'active' && cycleLang.cycle_lang_type == 'collectif_programme')
                    .map(cycleLang => <CycleLang
                        key={cycleLang.id_cycle_lang}
                        cycleLang={cycleLang}
                        setActiveCycleLang={setActiveCycleLang}
                        cycleLangList={cycleLangList}
                        idEventContactType={idEventContactType}
                    />)
                }

            </ul>
            }

            {collectifGeographiqueList

                && !cycleLangTypeList.includes("collectif_planaction")

                && <ul className="grid lg:grid-cols-3  md:grid-cols-2 grid-cols-1 "
                    columns={cycleLangTypeList.includes('collectif_geographique') ? 3 : 2} >

                    {!collectifGeographiqueList ? <Loader /> : collectifGeographiqueList
                        .filter((cycleLang, index, self) =>
                            index === self.findIndex((t) => (
                                t && t.id_cycle_lang === cycleLang.id_cycle_lang
                            ))
                        )
                        .filter(cycleLang => cycleLang.cycle_lang_state == 'active' && cycleLang.cycle_lang_type == 'collectif_geographique')
                        .map(cycleLang => <CycleLang
                            key={cycleLang.id_cycle_lang}
                            cycleLang={cycleLang}
                            setActiveCycleLang={setActiveCycleLang}
                            cycleLangList={cycleLangList}
                            idEventContactType={idEventContactType}
                        />)}
                </ul>
            }

            {/* 
*/}


            {cycleLangListMain
                && formulaire.collectif_geographique_section_is_visible == "0"
                && cycleLangListMain.length == 1 && <ul className="grid lg:grid-cols-3  md:grid-cols-2 grid-cols-1 divide-y"
                    columns={cycleLangTypeList.includes('collectif_geographique') ? 3 : 2} >
                    {!cycleLangList ? <Loader /> : cycleLangList
                        .filter((cycleLang, index, self) =>
                            index === self.findIndex((t) => (
                                t && t.id_cycle_lang === cycleLang.id_cycle_lang
                            ))
                        )
                        .filter(cycleLang => cycleLang.cycle_lang_state == 'active' && cycleLang.cycle_lang_type == 'collectif_programme')
                        .map(cycleLang => <CycleLang
                            key={cycleLang.id_cycle_lang}
                            cycleLang={cycleLang}
                            setActiveCycleLang={setActiveCycleLang}
                            cycleLangList={cycleLangList}
                            idEventContactType={idEventContactType}
                        />)}
                </ul>
            }

            {cycleLangTypeList.includes('collectif_sectoriel') && <RegistrationFormProgrammeInnovation cycleLang={activeCycleLang} />}
            {/* 
            <OnboardingFormGeographiqueEnd
                sectionBodyEnd={sectionBodyEnd} /> */}
        </>
        }

    </RegistrationFormSection>
}

export default RegistrationFormCycleLangSection;